import { render, staticRenderFns } from "./SVGNoItem.vue?vue&type=template&id=772e6c1b&scoped=true&"
import script from "./SVGNoItem.vue?vue&type=script&lang=js&"
export * from "./SVGNoItem.vue?vue&type=script&lang=js&"
import style0 from "./SVGNoItem.vue?vue&type=style&index=0&id=772e6c1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e6c1b",
  null
  
)

export default component.exports